var _excluded = ["metadata"],
  _excluded2 = ["metadata"],
  _excluded3 = ["Component"],
  _excluded4 = ["Component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { isValidElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getThemeKey } from '@deephaven/components';
import { vsPreview } from '@deephaven/icons';
import Log from '@deephaven/log';
import { isWidgetPlugin, isThemePlugin, isElementPlugin, isLegacyPlugin, isMultiPlugin, isPlugin, isWidgetDashboardPlugin } from "./PluginTypes.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('@deephaven/plugin.PluginUtils');

/**
 * Get a display-friendly name for a React component.
 * Prefers displayName, falls back to name, then the provided fallback.
 */
function getComponentName(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
component) {
  var _ref, _component$displayNam;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';
  return (_ref = (_component$displayNam = component.displayName) !== null && _component$displayNam !== void 0 ? _component$displayNam : component.name) !== null && _ref !== void 0 ? _ref : fallback;
}
export function pluginSupportsType(plugin, type) {
  if (plugin == null || !isWidgetPlugin(plugin)) {
    return false;
  }
  return [plugin.supportedTypes].flat().some(t => t === type);
}

/**
 * Check if the given plugin supports opening a widget of the given type as a dashboard.
 * @param plugin Plugin to check
 * @param type Widget type
 * @returns True if plugin supports opening it as a dashboard
 */
export function pluginSupportsTypeAsDashboard(plugin, type) {
  if (plugin == null || !isWidgetDashboardPlugin(plugin)) {
    return false;
  }
  return [plugin.dashboardTypes].flat().some(t => t === type);
}
export function getIconForPlugin(plugin) {
  var defaultIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
    icon: vsPreview
  });
  if (!isWidgetPlugin(plugin)) {
    return defaultIcon;
  }
  var icon = plugin.icon;
  if (icon == null) {
    return defaultIcon;
  }
  if (/*#__PURE__*/isValidElement(icon)) {
    return icon;
  }
  return /*#__PURE__*/_jsx(FontAwesomeIcon, {
    icon: icon
  });
}

/**
 * Extract theme data from theme plugins in the given plugin map.
 * @param pluginMap
 */
export function getThemeDataFromPlugins(pluginMap) {
  var themePluginEntries = [...pluginMap.entries()].filter(entry => isThemePlugin(entry[1]));
  log.debug('Getting theme data from plugins', themePluginEntries);
  return themePluginEntries.map(_ref2 => {
    var _ref3 = _slicedToArray(_ref2, 2),
      pluginName = _ref3[0],
      plugin = _ref3[1];
    // Normalize to an array since config can be an array of configs or a
    // single config
    var configs = Array.isArray(plugin.themes) ? plugin.themes : [plugin.themes];
    return configs.map(_ref4 => {
      var name = _ref4.name,
        baseTheme = _ref4.baseTheme,
        styleContent = _ref4.styleContent;
      return {
        baseThemeKey: "default-".concat(baseTheme !== null && baseTheme !== void 0 ? baseTheme : 'dark'),
        themeKey: getThemeKey(pluginName, name),
        name,
        styleContent
      };
    });
  }).flat();
}

/**
 * Get a mapping of element names to their React components from the given plugin map.
 * @param pluginMap The plugin map to extract element plugins from.
 * @returns A Map of element names to their React components.
 */
export function getPluginsElementMap(pluginMap) {
  var elementPluginEntries = [...pluginMap.entries()].filter(entry => isElementPlugin(entry[1]) && entry[1].mapping != null);
  log.debug('Getting element plugin mapping', elementPluginEntries);
  return new Map(elementPluginEntries.flatMap(_ref5 => {
    var _ref6 = _slicedToArray(_ref5, 2),
      plugin = _ref6[1];
    return Object.entries(plugin.mapping);
  }));
}

/**
 * Creates a component that chains middleware around a base component.
 * Each middleware wraps the next, with the base component at the innermost layer.
 */
export function createChainedComponent(baseComponent, middleware) {
  if (middleware.length === 0) {
    log.debug('No middleware to chain for component', getComponentName(baseComponent));
    return baseComponent;
  }
  log.debug('Chaining component middleware', getComponentName(baseComponent), middleware.map(m => m.name));

  // Build the chain from inside out (base component is innermost)
  // Middleware is ordered outermost to innermost, so we reverse to build from inside out
  return [...middleware].reverse().reduce((WrappedComponent, middlewarePlugin) => {
    var MiddlewareComponent = middlewarePlugin.component;
    var supported = [middlewarePlugin.supportedTypes].flat();
    function ChainedComponent(_ref7) {
      var metadata = _ref7.metadata,
        rest = _objectWithoutProperties(_ref7, _excluded);
      // Skip middleware if the widget type doesn't match its supportedTypes
      if ((metadata === null || metadata === void 0 ? void 0 : metadata.type) != null && !supported.includes(metadata.type)) {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread(_objectSpread({}, rest), {}, {
          metadata: metadata
        }));
      }
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        _jsx(MiddlewareComponent
        // eslint-disable-next-line react/jsx-props-no-spreading
        , _objectSpread(_objectSpread({}, rest), {}, {
          metadata: metadata,
          Component: WrappedComponent
        }))
      );
    }
    ChainedComponent.displayName = "".concat(middlewarePlugin.name, "(").concat(getComponentName(WrappedComponent), ")");
    return ChainedComponent;
  }, baseComponent);
}

/**
 * Creates a panel component that chains middleware around a base panel component.
 * Each middleware panel wraps the next, with the base panel at the innermost layer.
 *
 * The chain forwards the `ref` injected by golden-layout (on the registered
 * panel) all the way down to `basePanelComponent`. Golden-layout uses that ref
 * to bind a class panel's React state into its serialized `componentState`;
 * forwarding it keeps that persistence working through transparent middleware,
 * so wrapped panels still restore sorts/filters/column moves on reload.
 */
export function createChainedPanelComponent(basePanelComponent, middleware) {
  // Filter to middleware that has a panelComponent and extract just the panel components

  var panelMiddleware = middleware.filter(m => m.panelComponent != null);
  if (panelMiddleware.length === 0) {
    log.debug('No panel middleware to chain for panel component', getComponentName(basePanelComponent));
    return basePanelComponent;
  }
  log.debug('Chaining panel middleware', getComponentName(basePanelComponent), panelMiddleware.map(m => m.name));

  // Build the chain from inside out (base panel is innermost)
  return [...panelMiddleware].reverse().reduce((WrappedPanel, middlewarePlugin) => {
    var MiddlewarePanelComponent = middlewarePlugin.panelComponent;
    var supported = [middlewarePlugin.supportedTypes].flat();
    var ChainedPanel = /*#__PURE__*/React.forwardRef((_ref8, ref) => {
      var metadata = _ref8.metadata,
        rest = _objectWithoutProperties(_ref8, _excluded2);
      // Only forward the ref when golden-layout actually provides one.
      // Spreading an empty object (rather than passing `ref={null}`) keeps
      // a plain function-component base panel on a non-golden-layout render
      // path from being handed a ref prop it can't accept.
      var refProps = ref != null ? {
        ref
      } : {};
      // Skip middleware if the widget type doesn't match its supportedTypes
      if ((metadata === null || metadata === void 0 ? void 0 : metadata.type) != null && !supported.includes(metadata.type)) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/jsx-props-no-spreading
          _jsx(WrappedPanel, _objectSpread(_objectSpread(_objectSpread({}, refProps), rest), {}, {
            metadata: metadata
          }))
        );
      }
      return /*#__PURE__*/_jsx(MiddlewarePanelComponent
      // eslint-disable-next-line react/jsx-props-no-spreading
      , _objectSpread(_objectSpread(_objectSpread({}, refProps), rest), {}, {
        metadata: metadata,
        Component: WrappedPanel
      }));
    });
    ChainedPanel.displayName = "".concat(middlewarePlugin.name, "Panel(").concat(getComponentName(WrappedPanel, 'Panel'), ")");
    return ChainedPanel;
  }, basePanelComponent);
}

/**
 * What a middleware body hook returns. Both fields are optional:
 *
 * - `inject`: extra props merged onto the wrapped `Component`, threaded down
 *   the middleware chain. Use it to forward IrisGrid-aware props (e.g.
 *   `transformModel`, `transformTableOptions`, `onModelChanged`) without
 *   hand-writing the widening cast on `Component`.
 * - `wrap`: an optional wrapper placed *around* the wrapped component (e.g. a
 *   context provider). Receives the already-rendered child element and must
 *   return an element that renders it.
 */

/**
 * A hook implementing the body of a middleware. Receives the incoming props
 * (without `Component`) and returns an optional set of props to inject plus an
 * optional wrapper. The same body hook can back both a panel and a widget
 * middleware (see {@link createPanelMiddleware} / {@link createWidgetMiddleware}),
 * so a plugin expresses its behavior once.
 *
 * Type the `props` parameter as wide as the middleware needs (e.g. intersect
 * with `IrisGridTableOptionsWidgetProps`) — the factory passes the runtime
 * props through unchanged.
 */

/**
 * Builds a panel-path middleware component from a single body hook, owning the
 * `React.forwardRef` ceremony and ref forwarding that golden-layout state
 * persistence depends on.
 *
 * The returned component is ref-capable and always forwards its `ref` to the
 * wrapped `Component`, so a middleware author can never accidentally drop it
 * (which would silently break `componentState` persistence — sorts, filters,
 * column moves — on reload). The body hook only decides what to inject and how
 * to wrap; it never sees the ref.
 */
export function createPanelMiddleware(useBody) {
  var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'PanelMiddleware';
  var PanelMiddleware = /*#__PURE__*/React.forwardRef((_ref9, ref) => {
    var Component = _ref9.Component,
      rest = _objectWithoutProperties(_ref9, _excluded3);
    var _useBody = useBody(rest),
      inject = _useBody.inject,
      wrap = _useBody.wrap;
    var Next = Component;
    var child =
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _jsx(Next, _objectSpread(_objectSpread({
      ref: ref
    }, rest), inject));
    return wrap != null ? wrap(child) : child;
  });
  PanelMiddleware.displayName = displayName;
  return PanelMiddleware;
}

/**
 * Builds a widget-path middleware component from a single body hook. The widget
 * path takes no ref, so this is a plain function component; otherwise it mirrors
 * {@link createPanelMiddleware} (same `inject` / `wrap` contract), letting a
 * plugin reuse one body hook for both paths.
 */
export function createWidgetMiddleware(useBody) {
  var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'WidgetMiddleware';
  function WidgetMiddleware(_ref0) {
    var Component = _ref0.Component,
      rest = _objectWithoutProperties(_ref0, _excluded4);
    var _useBody2 = useBody(rest),
      inject = _useBody2.inject,
      wrap = _useBody2.wrap;
    var Next = Component;
    var child =
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _jsx(Next, _objectSpread(_objectSpread({}, rest), inject));
    return wrap != null ? wrap(child) : child;
  }
  WidgetMiddleware.displayName = displayName;
  return WidgetMiddleware;
}
function hasDefaultExport(value) {
  return typeof value === 'object' && value != null && value.default != null && typeof value.default === 'object';
}

/**
 * Get the PluginModule value from a loaded module export. Handles:
 * - Direct Plugin exports (`export default myPlugin`)
 * - Named default exports (`{ default: myPlugin, ...namedExports }`)
 * - Legacy plugin formats (`{ DashboardPlugin, AuthPlugin, TablePlugin }`)
 *
 * TypeScript builds CJS default exports differently depending on whether
 * there are also named exports. If the default is the only export, it will
 * be the value. If there are also named exports, it will be assigned to
 * the `default` property on the value.
 */
export function getPluginModuleValue(value) {
  if (isPlugin(value)) {
    return value;
  }
  if (hasDefaultExport(value) && isPlugin(value.default)) {
    return value.default;
  }
  if (isLegacyPlugin(value)) {
    return value;
  }
  return null;
}

/**
 * Register a plugin in the plugin map. If a plugin with the same name is
 * already registered, the duplicate is skipped and a warning is logged.
 * @param pluginMap The plugin map to register the plugin in
 * @param name The name to register the plugin under
 * @param plugin The plugin to register
 * @param version Optional version to attach to the plugin
 */
export function registerPlugin(pluginMap, name, plugin, version) {
  if (pluginMap.has(name)) {
    log.warn("Plugin '".concat(name, "' is already registered. Skipping duplicate."));
    return;
  }
  pluginMap.set(name, _objectSpread(_objectSpread({}, plugin), {}, {
    version
  }));
}

/**
 * Process a loaded plugin module: extract the plugin value, register in the
 * resolve map for cross-plugin imports, flatten MultiPlugins, and register
 * each resulting plugin in the plugin map.
 *
 * @param pluginMap The plugin map to register plugins in
 * @param resolveMap The module resolve map for cross-plugin imports
 * @param pluginExports The raw module exports from loading the plugin
 * @param name The manifest name of the plugin
 * @param packageName Optional package name for resolve map registration
 * @param version Optional version to attach to registered plugins
 */
export function processLoadedModule(pluginMap, resolveMap, pluginExports, name, packageName, version) {
  // Register raw module exports in the resolve map so subsequent
  // plugins can import this plugin by its package name
  if (packageName != null) {
    // eslint-disable-next-line no-param-reassign
    resolveMap[packageName] = pluginExports;
    log.debug("Registered plugin '".concat(packageName, "' in module resolve map"));
  }
  var moduleValue = getPluginModuleValue(pluginExports);
  if (moduleValue == null) {
    log.error("Plugin '".concat(name, "' is missing an exported value."));
    return;
  }
  if (isMultiPlugin(moduleValue)) {
    log.debug("MultiPlugin '".concat(name, "' contains ").concat(moduleValue.plugins.length, " plugins"));
    moduleValue.plugins.forEach(innerPlugin => {
      if (!isPlugin(innerPlugin)) {
        log.warn("Skipping invalid inner plugin from MultiPlugin '".concat(name, "'"), innerPlugin);
        return;
      }
      var innerPluginName = typeof innerPlugin.name === 'string' ? innerPlugin.name.trim() : '';
      if (innerPluginName.length === 0) {
        log.warn("Skipping unnamed inner plugin from MultiPlugin '".concat(name, "'"), innerPlugin);
        return;
      }
      registerPlugin(pluginMap, innerPluginName, innerPlugin, version);
    });
  } else {
    registerPlugin(pluginMap, name, moduleValue, version);
  }
}

/**
 * Group plugins into dependency levels for parallel loading. Plugins in the
 * same level have no dependencies on each other and can be loaded concurrently.
 * Each level's dependencies are fully contained in earlier levels.
 *
 * Handles cycles gracefully by placing remaining plugins into a final level
 * and logging an error.
 *
 * @param plugins The plugin list from the manifest
 * @returns An array of levels, where each level is an array of plugins
 */
export function groupByDependencyLevel(plugins) {
  // Map from package name to plugin for dependency resolution
  var packageToPlugin = new Map();
  plugins.forEach(p => {
    var _p$loader;
    if (((_p$loader = p.loader) === null || _p$loader === void 0 ? void 0 : _p$loader.package) != null) {
      packageToPlugin.set(p.loader.package, p);
    }
  });

  // Resolve each plugin's in-manifest dependencies
  var deps = new Map();
  plugins.forEach(p => {
    var _p$loader2;
    var resolved = new Set();
    if (((_p$loader2 = p.loader) === null || _p$loader2 === void 0 ? void 0 : _p$loader2.dependencies) != null) {
      p.loader.dependencies.forEach(dep => {
        var depPlugin = packageToPlugin.get(dep);
        if (depPlugin != null) {
          resolved.add(depPlugin);
        } else {
          log.warn("Plugin '".concat(p.name, "' depends on '").concat(dep, "' which is not in the manifest"));
        }
      });
    }
    deps.set(p, resolved);
  });
  var levels = [];
  var remaining = new Set(plugins);
  var loaded = new Set();
  var _loop = function _loop() {
    // Collect plugins whose dependencies are all loaded
    var level = [];
    remaining.forEach(p => {
      var pDeps = deps.get(p);
      if (pDeps == null || pDeps.size === 0) {
        level.push(p);
        return;
      }
      var allLoaded = true;
      pDeps.forEach(d => {
        if (!loaded.has(d)) {
          allLoaded = false;
        }
      });
      if (allLoaded) {
        level.push(p);
      }
    });
    if (level.length === 0) {
      // Cycle detected — load remaining plugins together as a final level
      var inCycle = [...remaining].map(p => p.name);
      log.error("Circular plugin dependency detected among: ".concat(inCycle.join(', '), ". Loading remaining plugins together."));
      levels.push([...remaining]);
      return 1; // break
    }
    levels.push(level);
    level.forEach(p => {
      remaining.delete(p);
      loaded.add(p);
    });
  };
  while (remaining.size > 0) {
    if (_loop()) break;
  }
  return levels;
}

/**
 * Get the WidgetPlugin that supports opening a widget of the given type as a dashboard.
 * @param pluginMap Map of available plugins
 * @param type Type of widget to check
 * @returns The WidgetPlugin that supports opening this widget as a dashboard, or null if no matching plugin is found
 */
export function getWidgetDashboardPlugin(pluginMap, type) {
  var _find;
  return (_find = [...pluginMap.values()].find(entry => isWidgetDashboardPlugin(entry) && [entry.dashboardTypes].flat().some(t => t === type))) !== null && _find !== void 0 ? _find : null;
}
//# sourceMappingURL=PluginUtils.js.map